<template>

<com-item name="game.peers.countrating" :size="size" :loading="loading" :is-empty="!active" title="Rating by Count Play Share">

	<template v-slot:about>

		<p>Avg rating by player count and play share.</p>

	</template>

	<template v-slot:stats>

		<core-widget class="countrating-graph" :scroll="true">

			<app-visualisation-heatmap :data="graph" />

		</core-widget>

	</template>

</com-item>

</template>

<script>

import comItem from './../common/Item'

export default {

	props: ['fetching', 'your', 'you', 'size'],

	components: {
		'com-item': comItem
	},

	data: function() {

		return {
			graph: {
				noClick: true,
				datasets: [
					{ data: [] }
				],
				values: {},
				axis: {
					x: {
						labels: ['1p', '2p', '3p', '4p', '5p', '6p'],
						thresholds: [1, 2, 3, 4, 5, 6]
					},
					y: {
						labels: ['85-100%', '70-85%', '55-70%', '40-55%'],
						thresholds: [0, 1, 2, 3, 4]
					}
				}
			}
		}

	},

	computed: {

		loading: function() { return this.fetching === 'all' },

		data: function() { return this.$store.getters['page/insights/game/peers'] },

		active: function() { return this.data && !this.loading && this.data.countRatingGrid && this.data.countRatingGrid.length }

	},

	created: function() { this.visualise() },

	watch: { data: function() { this.visualise() } },

	methods: {

		ratingBand: function(rating) {

			if (!rating) return 0
			return Math.min(10, Math.max(1, Math.floor(rating)))

		},

		visualise: function() {

			if (!this.data || !this.data.countRatingGrid) return

			this.graph.datasets[0].data = []
			var values = {}

			var xThresholds = this.graph.axis.x.thresholds
			var shareThresholds = [40, 55, 70, 85, 101]

			var yLabelCount = this.graph.axis.y.labels.length

			this.data.countRatingGrid.forEach(function(item) {

				// Find x bucket from player count
				var xIdx = -1

				for (var xi = 0; xi < xThresholds.length; xi++) {
					if (xThresholds[xi] > item.count) { xIdx = xi - 1; break }
				}
				if (xIdx === -1) xIdx = 0
				if (xIdx === -2) xIdx = xThresholds.length - 1

				// Find y bucket from share percentage using original ascending thresholds
				var yIdx = -1

				for (var yi = 0; yi < shareThresholds.length; yi++) {
					if (shareThresholds[yi] > item.sharePct) { yIdx = yi - 1; break }
				}
				if (yIdx === -1) yIdx = 0
				if (yIdx === -2) yIdx = shareThresholds.length - 2

				// Invert y-index to match reversed labels (85-100% at top)
				var invertedYIdx = (yLabelCount - 1) - yIdx

				// Feed a data point with inverted y so heatmap places it in the correct row
				this.graph.datasets[0].data.push({
					x: item.count,
					y: invertedYIdx,
					count: 1
				})

				var key = xIdx + '_' + invertedYIdx

				var shareLabel = (invertedYIdx >= 0 && invertedYIdx < yLabelCount) ? this.graph.axis.y.labels[invertedYIdx] : ''

				values[key] = {
					display: item.rating.toFixed(1),
					band: this.ratingBand(item.rating),
					tooltip: item.rating.toFixed(1) + ' avg rating<small>' + item.count + 'p · ' + shareLabel + ' share · ' + item.raters + ' rater' + (item.raters === 1 ? '' : 's') + '</small>'
				}

			}.bind(this))

			this.graph.values = values

		}

	}

}

</script>

<style scoped>

.countrating-graph {
	width: 100%;
	height: 100%;
	height: 320px;
}

</style>
